import logo from './riskybiscuit.jpg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          My name is biscuit and I need some ham
        </p>
      </header>
    </div>
  );
}

export default App;
